import { Router } from '@angular/router';

import { StoreService } from '@common/services/store.service';
import { CommonDialogsService } from '@common/dialogs/common-dialogs.service';

import { CredentialsService } from '../credentials.service';
import {ExternalAccessRefreshTokenResponse} from '@common/models/access-refresh-token-model';
import { Login } from '../login';
import {environment as env_const} from '@env/environment';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

export class ExternalLogin extends Login {
  constructor(
    protected router: Router,
    protected store: StoreService,
    protected commonDialog: CommonDialogsService,
    protected credentialsService: CredentialsService,
  protected translate: TranslateService
) {
    super(router, store, commonDialog, credentialsService, translate);
  }

  protected validExternalLogin(code: string, iss: string, sessionState: string) {
    this.commonDialog.showTranslatedSpinner(
      this.translationPath + 'messages.validExternalLogin'
    );

    this.externalLoginOnInit(code, iss, sessionState);
  }

  protected invalidExternalLogin() {
    this.commonDialog.showTranslatedSpinner(
      this.translationPath + 'messages.invalidExternalLogin'
    );

    setTimeout(
      () => this.router.navigate([env_const.loginUrl]),
      1000
    );
  }

  protected externalLoginOnInit(code: string, iss: string, sessionState: string): void {
    this.store.clearStoredUser();

    if (code && iss && sessionState) {
      console.log('Código recibido:', code);
      console.log('Estado de sesión:', sessionState);

      this.credentialsService.getTokenUsingExternalService$(code, iss, sessionState)
        .subscribe({
          next: (externalTokenResponse) =>
            this.onTokenUsingExternalServiceResponse(externalTokenResponse),
          error: (externalTokenError) => this.onInvalidLogin(externalTokenError),
        });
    } else {
      // Si no se recibe un código, manejar el error (por ejemplo, mostrar un mensaje)
      console.error('No se recibió el código de autenticación de MOTIVATE XR.');
      setTimeout(() => this.router.navigate([env_const.loginUrl]), 3000);
    }
  }

  private onTokenUsingExternalServiceResponse( response: ExternalAccessRefreshTokenResponse ) {
    this.onTokenResponse( response.username, response );
  }

  protected onInvalidLogin(responseData): Observable<any> {
    const observable = super.onInvalidLogin(responseData);
    observable.subscribe({
      next: () => this.router.navigate([env_const.loginUrl]),
      error: () => this.router.navigate([env_const.loginUrl]),
    });

    return observable;
  }
}
